export default {
    upload: {
        browse: 'Browse...',
        fileTooBig: "The total size can't be more then {maximumSize}.",
        selectFile: 'Select the file...',
        selectOrDrag: 'Drag your files or click here to browse your device...',
    },
};
